import { AppBar, Avatar, Button, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { ExitDoorWhite, ShikumLogo } from 'Images';

export const Header = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.DisabilityCalculator);

  return (
    <AppBar
      position='sticky'
      sx={{
        display: 'flex',
        flexFlow: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        background: '#081E54',
        height: '72px',
        width: '100%',
        padding: '4px 16px',
        gap: '11.68px',
      }}
    >
      <Avatar
        alt=''
        src={ShikumLogo}
        sx={{ width: '32.69px', height: '35.41px' }}
      />
      <Typography variant='body2'>{dictionary.pageName}</Typography>
      <Button
        variant='primary'
        sx={{
          p: '6px 10px',
          borderRadius: '6px',
          ml: '0px',
          mr: 'auto',
          gap: '4px',
        }}
        onClick={() => {
          window.history.back();
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '16px',
          }}
        >
          {dictionary.exit}
        </Typography>
        <Avatar
          alt=''
          src={ExitDoorWhite}
          sx={{ width: '22px', height: '22px' }}
        />
      </Button>
    </AppBar>
  );
};
